import HomeFooter from "@Organism/Home/Business/HomeFooter";
import Styles from "./style.module.scss";
import HeroAdsSeekersLanding from "@Organism/Home/AdsSseekerLanding/HomeOpeningBanner";
import OurAdvantagesAdsJobSeeker from "@Organism/Home/AdsSseekerLanding/OurAdvantagesAdsJobSeeker";
import StepsJobPosting from "@Organism/Home/AdsSseekerLanding/CreateJobsPostingSteps";
import FormContactUs from "@Organism/Home/AdsSseekerLanding/FormContactUs";

export default function AdsSeekersLandingPage() {
  return (
    <div className={Styles.main}>
      <HeroAdsSeekersLanding />
      <OurAdvantagesAdsJobSeeker />
      <StepsJobPosting />
      <FormContactUs />
      <HomeFooter />
    </div>
  );
}
